import React, { useState } from "react";
import ReactSVG from "react-svg";
import cx from "classnames";
import Popup from "../Popup";

const KebabActions = props => {
    const { actions, breadcrumbData } = props;
    const [isOpen, openPopup] = useState(false);
    const onTogglePopup = () => openPopup(!isOpen);

    const secondaryActions = actions.filter(action => !action.primary && action.show);

    const renderButtons = button => {
        const { handler, name, show, disabled } = button;

        let isDisabled = disabled;
        if (disabled && typeof disabled === "function") {
            isDisabled = disabled(breadcrumbData);
        }
        const onClick = () => {
            openPopup(false);
            handler(breadcrumbData);
        };
        if (show) {
            return (
                <button
                    key={name}
                    type="button"
                    className={cx("popup-link", { disabled: isDisabled })}
                    disabled={isDisabled}
                    onClick={onClick}
                >
                    {name}
                </button>
            );
        }
    };

    return (
        <div className={cx("actions", { open: isOpen })}>
            {/* <button
                type='button'
                className='btn-add'
                onClick={onTogglePopup}
            >
                <i className='icon-kebab-vert' />
            </button> */}
            {/* <ReactSVG
                className="action-chevron-wrapper"
                svgClassName="action-chevron-icon"
                src={`/data/svg/chevron.svg`}
                onClick={onTogglePopup}
            /> */}
            <div className="action-chevron-wrapper button-hover-half-circle" onClick={onTogglePopup}>
                <ReactSVG
                    className="action-chevron-wrapper button-icon"
                    svgClassName="action-chevron-icon"
                    src={`/data/svg/chevron.svg`}
                />
            </div>
            {isOpen && (
                <Popup place="breadcrumbs-actions-popup" onClickOutside={onTogglePopup}>
                    {actions.filter(action => action.primary).map(renderButtons)}
                    {secondaryActions && secondaryActions.length > 0 && (
                        <>
                            <div className="separator" />
                            {secondaryActions.map(renderButtons)}
                        </>
                    )}
                </Popup>
            )}
        </div>
    );
};

export default KebabActions;
